module.exports = __webpack_public_path__ + "img/iihf-logo.12bc5250.jpg";